export default __webpack_public_path__ + "static/media/capture.f136a3e6.png";